import React from "react"
import {
  Section,
  Container,
  Column,
  Columns,
  Button,
  Content,
} from "bloomer"

import Layout from "../../components/layout"
import SEO from "../../components/seo"
import OutrosJogos from "../../components/outros-jogos"
import CardIndex from "../../components/card-index"
import ReadingResult from "../../components/reading-result"
import data from "../../data/oraculo/baralho-cigano/baralho-cigano.json"

export default class BaralhoCigano extends React.Component {
  state = {
    selected: [],
    random:[],
  }

  
  handleClick = event => {
    let random = [...data]; // copia: no mutar el JSON compartido
    for (let i = random.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [random[i], random[j]] = [random[j], random[i]];
    }
    //let random = data.sort(() => .5 - Math.random())
    this.setState({random:random})
    this.setState({selected:[]})
  }

  render() {
    var parent = this
    const {selected, random} = this.state;
    let items =""
    // Cartas del RESULTADO normalizadas para <ReadingResult> (posiciones abajo)
    const readingCards = selected.length === 3
      ? selected.filter(c => c && c["id"]).map(item => ({
          image: require("../../data/oraculo/baralho-cigano/images/" + item["id"] + ".png"),
          title: item["title"],
          lines: [
            { label: "Significado", text: item["description"] },
            { label: "Interpretação", text: item["interpretation"] },
          ],
        }))
      : []
    if(random.length && selected.length<3){
         items = random.map(function(item, i){
            if(item['id']){
                const active = selected.includes(item)
                const image = require("../../data/oraculo/baralho-cigano/images/"+item["id"]+".png")
                return (
                       <Button 
                            key={i}
                            onClick={() => {
                                if(!active){
                                  const selectedtmp = selected;   
                                  selectedtmp.push(item);   
                                  parent.setState({selected:selectedtmp})
                                }                            
                            }}
                            className={active?'is-active column ':'column'}
                        >
                            <img src={image} alt={item['title']}/>
                        </Button>
                
                )
            }else{
                return ""
            }
            
        });
        items = <Columns className="deck" isMobile isMultiline>{items}</Columns>
    }
    if(selected.length<3 && !random.length){
      items = <Button className="is-primary" onClick={() => { parent.handleClick()}}>Jogar</Button>
    }
    
 
    return (
      <Layout>
        <SEO title="Baralho Cigano - EstrelaGuia" />
          <Container>
            <Columns>
              <Column>
                <Content>
                  <h1>Baralho Cigano</h1>
                  <p>
                    Procure mentalizar sua pergunta com bastante intensidade antes de tirar as cartas, preferindo ambientes silenciosos ou, pelo menos,
                    desligando-se de qualquer coisa exterior que possa desviar a sua atenção. O foco na questão é muito importante e, portanto,
                    busque fazer perguntas objetivas e com sinceridade máxima. Depois, clique em <strong>Jogar</strong> e escolha 3 cartas.
                  </p>
                </Content>
                {selected.length === 3 ? (
                  <ReadingResult
                    cards={readingCards}
                    positions={["Situação", "Desafio", "Tendência"]}
                    game="baralho-cigano"
                    pageType="baralho-cigano"
                    onReset={() => parent.handleClick()}
                  />
                ) : (
                  <Content>{items}</Content>
                )}
                <Content>
                  <h2>O que é o Baralho Cigano</h2>
                  <p>
                    O baralho cigano surgiu na Europa e criou uma tradição que o consolidou como um dos oráculos mais difundidos do mundo.
                    Cada carta possui um significado específico, o que não dá margem para ambivalências e faz dele um dos mais diretos e
                    objetivos sistemas de adivinhação que existem.
                  </p>
                  <p>
                    As lâminas são associadas aos quatro naipes do baralho comum, que orientam o assunto relativo
                    à sua questão.
                  </p>
                  <p>
                    A forma de jogar é elucidativa e simples: se houver predominância de cartas negativas, a sua questão
                    não está num bom caminho. Por outro lado, a ênfase nas cartas positivas indica que a sua
                    questão está caminhando para o sucesso. As possíveis cartas negativas indicarão os problemas e empecilhos
                    na solução da sua pergunta, assim como as cartas positivas revelarão as virtudes envolvidas e a proteção do
                    plano superior.
                  </p>
                  <h2>O simbolismo dos naipes</h2>
                  <ul>
                    <li>Copas: corresponde ao elemento Água e fala dos sentimentos, da feminilidade, das emoções e do amor.</li>
                    <li>Ouros: simboliza o elemento Terra, a Grande Mãe, a existência material, a família, a casa e o dinheiro.</li>
                    <li>Espadas: é regido pelo elemento Ar e corresponde ao intelecto, à mente, às ideias, o pensamento e a criatividade.</li>
                    <li>Paus: simboliza o elemento Fogo e representa a concretização, afirmação, imaginação, as forças transformadoras do Universo e a
                    motivação.</li>
                  </ul>
                </Content>
              {selected.length !== 3 && <OutrosJogos atual="/oraculo/baralho-cigano/" />}
              </Column>
            </Columns>
          </Container>
          <Container>
            <CardIndex
              items={data}
              labelField="title"
              base="/oraculo/baralho-cigano"
              heading="Significado de cada carta do Baralho Cigano"
            />
          </Container>
      </Layout>
    )
  }
}


